import React, { useMemo, useState } from 'react'
import { usePageSettings } from '@providers/page-settings'
import { Button } from '@shared/components/button'

import { ProductCard } from './ProductCard'

import styles from './style.module.scss'

const SHORT_MODE_LEN = 6

export const View = () => {
	const settings = usePageSettings()

	const [isExpanded, setIsExpanded] = useState(false)
	const promoPages = useMemo(() => {
		const results = [...settings?.admin?.promoPages!]
			.sort((a, b) => (a?.order ?? 0) - (b?.order ?? 0))
			.map((page) => ({
				...page,
				url: settings.region?.contextCity ? `${settings.region.contextCity}${page!.url}` : page!.url,
			}))

		if (results.length <= SHORT_MODE_LEN) {
			setIsExpanded(true)
		}

		if (isExpanded) {
			return results
		}

		return results.slice(0, SHORT_MODE_LEN)
	}, [settings, isExpanded, settings.region?.contextCity])

	return (
		<div className={styles.wrapper}>
			<h2 className={styles.title}>Кредиты на любые цели</h2>
			<div className={styles.products}>
				{promoPages.map((lp) => {
					return <ProductCard key={lp.id} {...(lp as Required<typeof lp>)} />
				})}
			</div>
			{!isExpanded && (
				<Button
					onClick={() => setIsExpanded(true)}
					variant='outlined'
					size='m'
					className={styles.button}
				>
					Показать ещё
				</Button>
			)}
		</div>
	)
}
